'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _addressLookup = require('../../actions/address-lookup');
var _addressLookup2 = require('../../selectors/address-lookup');
var _select = require('../select');
var _select2 = _interopRequireDefault(_select);
var _controlFields = require('../../hocs/control-fields');
var _controlFields2 = _interopRequireDefault(_controlFields);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Multiple = function (_Component) {
  _inherits(Multiple, _Component);
  function Multiple() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Multiple);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Multiple.__proto__ || Object.getPrototypeOf(Multiple)).call.apply(_ref, [this].concat(args))), _this), _this.lookupAddress = function (jsonValue) {
      if (jsonValue) {
        var value = JSON.parse(jsonValue);
        _this.props.lookupAddress(_this.props.formId, value, _this.props.validate, _this.props.name);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Multiple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // If there is only one option, act as if the user selected it
      if (this.props.addressOptions.length === 1) {
        this.lookupAddress(this.props.addressOptions[0].value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_select2.default, {
        name: this.props.fieldNames.Options,
        placeholder: 'Select address',
        label: 'Select ' + (this.props.label ? this.props.label.toLowerCase() : 'address'),
        options: this.props.addressOptions,
        onChange: this.lookupAddress,
        extra: _react2.default.createElement('a', {
          onClick: this.props.clearAddress
        }, 'Try another lookup')
      }));
    }
  }]);
  return Multiple;
}(_react.Component);
Multiple.propTypes = {
  // props
  name: _propTypes.string.isRequired,
  clearAddress: _propTypes.func.isRequired,
  fieldNames: _propTypes.object.isRequired,
  label: _propTypes.string,
  // withFormValidator
  formId: _propTypes.string.isRequired,
  validate: _propTypes.func.isRequired,
  // stp
  addressOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  })).isRequired,
  // dtp
  lookupAddress: _propTypes.func.isRequired
};
exports.default = (0, _controlFields2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    addressOptions: (0, _addressLookup2.addressOptions)(state, ownProps.formId, ownProps.name)
  };
}, {
  lookupAddress: _addressLookup.lookupAddress
})(Multiple));